import React, {
  FC, useContext, useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ArticleBulkClientSelector } from '../../ArticleBulkClientSelector';
import { ArticleListContext } from '../articleListContext';
import { EditArticleDraftButton } from '../EditArticleDraftButton';
import { BudgetInvoiceComponent } from './types';
import Loader from 'components/base/Loader';
import { Row } from 'components/base/Row';

import { ArticleClientSelector } from 'modules/budget/components/ArticleClientSelector';
import { ArticleProviderSelector } from 'modules/budget/components/ArticleProviderSelector';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';
import { useBudget } from 'modules/budget/hooks/useBudget';
import { InvoiceArticle } from 'modules/budget/models/InvoiceArticle/types';
import { SetInvoiceArticles, SetInvoiceClients } from 'modules/budget/store/budgetActions';

import './index.scss';

export const BudgetInvoice: FC<BudgetInvoiceComponent> = ({ budgetId }) => {
  const { updateItem } = useContext(ArticleListContext);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    fetchInvoiceArticles,
    invoiceArticles,
    invoiceArticlesLoading,
    invoiceClients,
  } = useBudget();

  useEffect(
    () => {
      if (budgetId) {
        fetchInvoiceArticles(budgetId);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [budgetId],
  );

  useEffect(
    () => () => {
      dispatch(SetInvoiceArticles({ articles: [] }));
      dispatch(SetInvoiceClients({ clients: [] }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const ArticleRow = (item: InvoiceArticle): JSX.Element => {
    const isFlowersArticle = item.questionCode === BudgetQuestionCodes.Q14;

    return (
      <tr key={item.id} className="f-budget-invoice-article-row">
        <td className="f-budget-invoice-article-description">{item.description}</td>
        {!isFlowersArticle && (
        <React.Fragment>
          <td>
            <ArticleProviderSelector
              article={item}
              idBudget={budgetId}
            />
          </td>
          <td>
            <ArticleClientSelector
              article={item}
              clients={invoiceClients}
              idBudget={budgetId}
            />
          </td>
        </React.Fragment>
        )}
        <td>
          {isFlowersArticle
            ? (
              <React.Fragment>
                <span>
                  {item.recordArticles.length
                    ? `${t('budget.invoiceFlowersCompleteInfo')}:`
                    : t('budget.invoiceFlowersCompleteInfoNoIds')}
                </span>
                {item.recordArticles.map((recordArticle) => (
                  <EditArticleDraftButton
                    key={`flower-article-${recordArticle.recordArticleId}`}
                    articleId={recordArticle.recordArticleId}
                    articleStatus={recordArticle.status}
                    onAccept={(articleId, article) => {
                      updateItem(articleId, article);
                    }}
                  />
                ))}
              </React.Fragment>
            )
            : <div>&nbsp;</div>}
        </td>
      </tr>
    );
  };

  return (
    <div>
      {!invoiceArticlesLoading && invoiceArticles.length !== 0 && (
      <table>
        <tbody>
          <tr className="f-budget-invoice-article-row">
            <td>&nbsp;</td>
            <td>
              &nbsp;
            </td>
            <td>
              <ArticleBulkClientSelector
                articles={invoiceArticles}
                clients={invoiceClients}
                idBudget={budgetId}
              />
            </td>
            <td>&nbsp;</td>
          </tr>
          {invoiceArticles.map(ArticleRow)}
        </tbody>
      </table>
      )}
      {!invoiceArticlesLoading && invoiceArticles.length === 0 && (
        <Row><div>{t('common.noItems')}</div></Row>
      )}
      {invoiceArticlesLoading && (<Loader />)}
    </div>
  );
};
